import { EstimatRequestResponse } from '@/models/EstimateRequestResponse';
import { Site } from '@/models/Site';

export enum EstimateFormStep {
    first = 'selectSite',
    second = 'estimateForm',
}

export interface EstimateRequestState{
    objet: string
    descriptif: string
    documents: File[]
    date: string
    site?: Site
    step: EstimateFormStep
    isLoading: boolean
    success: boolean
    error?: Error
    response?: EstimatRequestResponse,
    isEditing: boolean
    editingEstimateId?: number
}

export const state: EstimateRequestState = {
    objet: '',
    descriptif: '',
    documents: [],
    date: '',
    step: EstimateFormStep.first,
    isLoading: false,
    success: false,
    isEditing: false,

};
